export const ERRORS = {
  primary:
    'Sense360 is currently down for maintenence and will be back up soon. We apologize for any inconvenience and appreciate your patience.',
  no_access:
    'You do not currently have access to Sense360, please contact us at sense360-support@medallia.com to get access',
}
